import 'component/css/order.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faFileImage,
} from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { padZero } from 'service/util';

import Loading from 'component/Loading';
import ModalScreen from 'component/ModalScreen';
import Protected from 'component/Protected';

import AddOrderModal from 'component/order/AddOrderModal';
import OrderDetailModal from 'component/order/OrderDetailModal';

const OrderList = (props) =>
{
  if (!Util.hasValue(props.owner)) throw `[${OrderList.name}] must provide owner`;

  const [error, setError]   = useState(null);
  const [orders, setOrders] = useState(null);

  const [modal, setModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');

  //-------------------------------------------------------
  const refreshData = () =>
  {
    API.getOrdersByCustomer(props.owner.id).then(data => {
      setOrders(data);
      setModal(false);
    }).catch(err => {
      setOrders(null);
      setError('讀取失敗，請聯絡系統管理員。');
    });
  }

  const showAddModal = () =>
  {
    let modal =
      <AddOrderModal owner={props.owner}
        selectedVehicleLicense={props.selectedVehicleLicense}
        onAdded={ o => setOrders([o, ...orders]) }
        onClose={ e => setModal(false) }/>;
    setModal(modal);
    setModalTitle('新訂單');
  }
  const showDetailModal = (order) =>
  {
    let modal = <OrderDetailModal order={order} refreshData={refreshData} />;
    setModal(modal);
    setModalTitle('訂單 - ' + order.ix_yrmo + '-' + Util.LPAD(order.id, 7));
  }

  //-------------------------------------------------------
  // init
  useEffect(() => {
    refreshData();
  }, [props.owner]);

  return (<>
    <div className="box order-list">
      <h4 className="box-head">
        <div className="action-panel">
          <span>訂單紀錄</span>
          <div>
            <Protected allow={['ADMIN','OPERATOR']}>
              <button type="button" className="btn small green"
                onClick={showAddModal}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </Protected>
          </div>
        </div>
      </h4>
      <div className="box-body">
        { !orders
        ?(!error?<Loading small={true} />:<p className="message red">{ error }</p>)
        :(!orders.length
          ?<p className="message yellow">無紀錄</p>
          :<div className="orders">
            <table className="data-table full-width">
              <colgroup>
                <col width="24px"  id="col-order-btn"/>
                <col width="100px" id="col-order-date"/>
                <col width="60px"  id="col-order-status"/>
                <col width="auto"  id="col-order-detail"/>
                <col width="80px"  id="col-order-mod-by"/>
              </colgroup>
              <thead>
                <tr>
                  <th className="col-order-btn"></th>
                  <th className="col-order-date">日期</th>
                  <th className="col-order-status">狀態</th>
                  <th className="col-order-detail">訂單</th>
                  <th className="col-order-mod-by">負責同事</th>
                </tr>
              </thead>
              <tbody>
                { orders?.map(odr =>
                  <tr key={`${odr.ix_yrmo}-${odr.id}`}>
                    <td className="col-order-btn" onClick={e=>showDetailModal(odr)}>
                      <FontAwesomeIcon icon={faFileImage} />
                    </td>
                    <td className="col-order-date">{ Util.ShortDate(odr.order_dtm) }</td>
                    <td className="col-order-status">{ Util.getPaymentType(odr.payment_type) }</td>
                    <td className="col-order-detail">
                      <strong className="d-order-id">編號: { `${odr.ix_yrmo}-${padZero(odr.id, 8)}` } / { odr.cd_license }</strong>
                      <ul className="d-order-item-list">
                        { odr.items.map(itm =>
                          <li key={itm.item_id} className="order-item">
                            <span className="d-item-name">{itm.srv_name} x{itm.qty}</span>
                            <span className="d-item-price">${ Util.nf2(itm.qty * itm.unit_price - itm.discount) }</span>
                          </li>
                        )}
                        <li className="order-item">
                          <i className="d-item-name">總計</i>
                          <strong className="d-item-price">
                            ${ Util.nf2( odr.items.reduce((r,itm) => r + itm.qty*itm.unit_price - itm.discount, 0) )}
                          </strong>
                        </li>
                      </ul>
                    </td>
                    <td className="col-irder-mod-by" title={ `更改日期: ${Util.ShortDate(odr.mod_dtm)}`}>{ odr.mod_by }</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
    <ModalScreen title={modalTitle} show={!!modal}
      onClose={ e=> setModal(false) }>
      { modal }
    </ModalScreen>
  </>);
}

export default OrderList;